/**
 * @packageDocumentation
 * @category Component
 */

import 'BomdisoftComponents/inputs/field/styles.css';
import { joinClasses } from 'BomdisoftComponents/html/index';
import type { FieldSize } from 'BomdisoftComponents/inputs/field/render';
import type { ReactNode } from 'react';

export type { FieldSize } from 'BomdisoftComponents/inputs/field/render';

export type FieldProps = {
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  error?: boolean;
  helperId?: string;
  helperText?: string;
  inputId?: string;
  label?: string;
  multiline?: boolean;
  required?: boolean;
  size?: FieldSize;
};

export const Field = ({ children, className, disabled, error, helperId, helperText, inputId, label, multiline, required, size = 'medium' }: FieldProps) => (
  <div className={joinClasses('bomdisoft-field', className)}>
    {label && (
      <label className='bomdisoft-field-label' data-disabled={disabled ? '' : undefined} data-error={error ? '' : undefined} data-required={required ? '' : undefined} htmlFor={inputId}>
        {label}
      </label>
    )}
    <div className='bomdisoft-field-box' data-disabled={disabled ? '' : undefined} data-error={error ? '' : undefined} data-multiline={multiline ? '' : undefined} data-size={size}>
      {children}
    </div>
    {helperText && (
      <p className='bomdisoft-field-helper' data-disabled={disabled ? '' : undefined} data-error={error ? '' : undefined} id={helperId}>
        {helperText}
      </p>
    )}
  </div>
);
